import changeTheState from "./loginLogout";
import changeDivision from "./divisionReducer";
import changeActiveTab from "./activeTabReducer";
import changeLoginState from "./loginstatred";
import selectStatements from "./statements";
import poToGrnReducer from "./poToGrnReducer";
import SelModule from "./selModule";
import { combineReducers } from "redux";

const rootReducers = combineReducers({
  changeTheState,
  changeLoginState,
  selectStatements,
  changeDivision,
  changeActiveTab,
  poToGrnReducer,
  SelModule,
});

export default rootReducers;
